let moduleVersion = "3.13.10";
export const getCurrentVersion = () => moduleVersion;
export const setCurrentVersion = version => {
  moduleVersion = version;
};
//# sourceMappingURL=version.js.map